import { ISurveyView, TimeScale } from 'store/survey/surveyTypes';
import i18n from '../../i18n';
import { getLanguageBaseOnTZ } from '../../utils/LanguageLocalStorage';

export default {
  addFilter: 'افزودن فیلتر',
  aban: 'آبان',
  addChildOfTag: 'افزودن برچسب‌های زیرمجموعه',
  addFilterToQuestion: 'فیلتر پرسش',
  addProviderInstanceToFilter: 'فیلتر هویت',
  addUserInstanceToFilter: 'فیلتر کاربر مرتبط',
  addNewChart: 'افزودن نمودار',
  addTag: 'افزودن برچسب‌',
  addTagToFilter: 'فیلتر برچسب',
  aggregateBy: 'دسته‌بندی بر اساس',
  all: 'همه',
  allOfTheReports: 'همه‌ی گزارش‌ها',
  allQuestionsSplit: '-تقسیم‌بندی تمام پرسش‌ها',
  allSubQuestionsSplit: '-تقسیم‌بندی تمام گام‌ها',
  avg: 'میانگین',
  azar: 'آذر',
  bahman: 'بهمن',
  bar: 'میله‌ای',
  baseDate: 'تاریخ مبنا',
  basedOn: 'بر اساس',
  baseDateIsBasedOnNow: 'تاریخ مبنا بر اساس امروز است',
  baseLine: 'حد پایین',
  canNotEditThisTypeOfReport:
    'این نوع از گزارش را فقط در پرسشنامه‌ی مربوطه می‌توان ویرایش کرد',
  chartType: 'نوع نمودار',
  checkPoints: 'اهداف',
  overallCheckPoints: 'اهداف کلی',
  couldNotSelectMoreThatTwoSplitItem:
    'بیشتر از دو مورد برای تقسیم‌بندی نمی‌توان انتخاب کرد',
  count: 'فراوانی',
  countOfReports: 'تعداد گزارش‌های ذخیره شده:',
  creatingNewReport: 'ایجاد گزارش جدید',
  cumulativeReport: 'گزارش تجمیعی',
  day: 'روز',
  datePicker: 'انتخابگر تاریخ',
  default: 'پیش‌فرض',
  delete: 'حذف',
  deleted: 'حذف شده',
  dey: 'دی',
  splitOnValues: 'به تفکیک پاسخ',
  moreThan2SplitsImpossible: 'گزارش نمی‌تواند بیش از دو تقسیم بندی داشته باشد',
  maximize: 'تمام صفحه',
  showList: 'نمایش لیست',
  downloadResponseList: 'دریافت لیست',
  print: 'چاپ',
  includeScore: 'نمایش امتیاز در خروجی',
  exportReportExcel: 'دریافت خروجی Excel گزارش',
  exportResponseExcel: 'دریافت خروجی Excel پاسخهای مرتبط',
  download: 'دریافت',
  updateAppliesToAllVersions:
    'توجه کنید به‌روز رسانی گزارش در تمام نسخه ها اعمال می‌شود. در صورتی که این را نمی خواهید به جای به روزرسانی گزارش دیگری بسازید',
  showPastYears: 'مقایسه با سال‌های گذشته - تعداد سال؟',
  dashboardWidth: 'طول در داشبورد',
  dashboardHeight: 'ارتفاع در داشبورد',
  showInTarget: 'نمایش پرسشنامه مرتبط',
  defaultViewType: 'حالت نمایش پیش فرض',
  splitOnFieldValues: 'تقسم بندی بر اساس گام',
  noSplit: 'بدون تقسیم بندی',
  quickAdd: 'ایجاد خودکار',
  generate: 'ایجاد گزارش‌های خودکار',
  groupInBSC: 'دسته بندی در نمایش جدولی',
  filterSelectTagRoots: 'تگ پدر گزینه‌های قابل فیلتر',
  forceFilter: 'فیلتر گزارش‌ها با تگ',
  defaultEndTime: 'تاریخ پایان پیشفرض',
  notRelatedCompany: 'گزارش مربوط به این مجموعه نیست',
  noItemFound: 'گزارش یافت نشد',
  copySurveyReport: 'کپی گزارش از پرسشنامه',
  pasteTaskReport: 'جایگذاری گزارش از وظایف',
  urlOrId: 'شناسه یا آدرس',
  icon: 'ایکون',
  addDashboardLinks: 'افزودن لینک',
  reportLinks: 'تنظیمات داشبورد',
  includeTotal: 'نمایش مقدار کل',
  more: '⬇ بیشتر',
  less: '⬆ کمتر',
  permissionFilterApplied:
    'با توجه به دسترسی شما، محدودیت های زیر در گزارش اعمال شده است',
  searchUser: 'جستجوی کاربر مرتبط',
  comparing: 'مقایسه‌ای بین',
  downloadReport: 'دریافت خروجی گزارش',
  downloadRelatedResponses: 'دریافت خروجی پاسخ‌های مرتبط',
  exportExcel: 'دریافت خروجی',
  filterTitle: 'عنوان فیلتر',
  defaultChart: 'نمودار پیشفرض',
  filters: 'فیلتر‌ها',
  apply: 'اعمال',
  reset: 'پیشفرض',
  noAutoReportExists: 'گزارش خودکاری وجود ندارد',
  autoReports: 'گزارش‌های پیشفرض',
  percentOfTotalAvgMainReport: 'درصد میانگین مقدار',
  totalAvgMainReport: 'میانگین مقدار',
  sumMainReport: 'جمع مقدار',
  reportValues: 'نمایش مقادیر به جای درصد',
  usePureValues: 'گزارش‌ مقدار',
  usePercentage: 'گزارش درصد',
  reportNotAccessible: 'این گزارش برای شما در دسترس نیست',
  reportSearchMandatoryTags:
    'جستجو و نمایش  گزارش‌های اصلی پرسشنامه با همه برچسب های زیر',

  fillCountName(
    useValue: boolean,
    timeScale: TimeScale,
    survey: ISurveyView,
    splitOn?: string
  ) {
    let s = 'تعداد';
    if (!useValue) s = this.percentage + ' فراوانی';
    s = ` ${s} ${this.reportNameExtractor(survey)} (به تفکیک`;
    if (splitOn) s = `${s} ${splitOn} و `;
    else s += ' ';
    return `${s}${this.getRangeName(timeScale)})`;
  },

  editingReport: (reportName?: string) => {
    if (reportName?.length ?? 0 > 0) {
      return i18n.t('editWithName', { ns: 'survey', reportName });
    }
    return i18n.t('editReport', { ns: 'survey' });
  },
  fillCount: 'تعداد',
  splitReports: 'به تفکیک سوال',
  commonGoals: 'اهداف مشترک گزارشها',
  reportName: 'عنوان گزارش',
  someQuestionsSplit: 'به تفکیک محور‌',
  extraReports: 'سایر گزارش‌ها (قابل مشاهده برای پشتیبان)',
  in: 'در',
  copied: 'کپی شد',
  currentName: 'عنوان گزارش کنونی',
  fillPercentage: 'درصد ارسال',
  copy: 'کپی',
  copyImage: 'کپی تصویر گزارش',
  end: 'پایان',
  esfand: 'اسفند',
  farvardin: 'فروردین',
  filterDataTitle: 'محدود کردن داده‌ها',
  filterDisplayTitle: 'محدود کردن نمایش نتایج',
  firstLevelBucket: 'تقسیم‌بندی بر اساس',
  fiveDays: '۵ روز',
  fiveWeeks: '۵ هفته',
  from: 'از ',
  fromStart: 'از ابتدای',
  fourHalfYear: 'چهار نیم‌سال',
  fourSeason: '۴ فصل',
  getHalfYearTitle: (monthNumber: number, year: string) => {
    if (monthNumber <= 6) {
      return i18n.t('firstHalfYearTitle', { ns: 'survey', year });
    }
    return i18n.t('secondHalfYearTitle', { ns: 'survey', year });
  },
  generateMetricName: (metricType: string) => {
    const lang = getLanguageBaseOnTZ();
    switch (metricType) {
      case 'avg':
        return lang === 'fa' ? 'میانگین' : 'Mean';
      case 'percentageOfAvg':
        return lang === 'fa' ? 'درصد میانگین' : 'Average Percentage';
      case 'count':
        return lang === 'fa' ? 'فراوانی' : 'Frequency';
      case 'totalAvg':
        return lang === 'fa' ? 'میانگین کل' : 'Total Average';
      case 'sum':
        return lang === 'fa' ? 'جمع' : 'Sum';
      case 'percentageOfTotalAvg':
        return lang === 'fa' ? 'درصد میانگین کل' : 'Overall Average Percentage';
      case 'percentageOfCount':
        return lang === 'fa' ? 'درصد فراوانی' : 'Overall Frequency';
      default:
        return lang === 'fa' ? 'نامشخص' : 'Unknown';
    }
  },
  getSeason(monthNumber: number, year: string) {
    switch (true) {
      case monthNumber <= 3:
        return `بهار ${year}`;
      case monthNumber > 3 && monthNumber <= 6:
        return `تابستان ${year}`;
      case monthNumber > 6 && monthNumber <= 9:
        return `پاییز ${year}`;
      case monthNumber > 9 && monthNumber <= 12:
        return `زمستان ${year}`;
      default:
        return `فصل ${year}`;
    }
  },
  getEnSeason(monthNumber: number, year: string) {
    switch (true) {
      case monthNumber <= 3:
        return `${year}, 1st Quarter`;
      case monthNumber > 3 && monthNumber <= 6:
        return `${year}, 2nd Quarter`;
      case monthNumber > 6 && monthNumber <= 9:
        return `${year}, 3rd Quarter`;
      case monthNumber > 9 && monthNumber <= 12:
        return `${year}, 4th Quarter`;
      default:
        return `${year}, Season`;
    }
  },
  halfYear: 'نیم‌سال',
  hideOtherCharts: 'پنهان کردن سایر نمودارها',
  invalidProvider: 'هویت نامعتبر',
  invalidTerm: 'فیلتر مورد نظر قابل اعمال نمی‌باشد',
  khordad: 'خرداد',
  limitBucket: 'محدود کردن نتایج',
  line: 'خطی',
  loading: 'در حال دریافت اطلاعات...',
  mehr: 'مهر',
  metric: 'معیار',
  month: 'ماه',
  mordad: 'مرداد',
  new: 'جدید',
  newReport: 'گزارش جدید',
  noData: 'داده‌ای برای این پرس‌وجو ثبت نشده است',
  oneDay: '۱ روز',
  oneHalfYear: 'یک نیم‌سال',
  oneMonth: '۱ ماه',
  oneSeason: '۱ فصل',
  oneWeek: '۱ هفته',
  oneYear: '۱ سال',
  ordibehesht: 'اردیبهشت',
  percentageOfRealization: 'درصد تحقق',
  percentageOfAvg: 'درصد میانگین',
  percentage: 'درصد',
  amount: 'مقدار',
  percentageOfTotalAvg: 'درصد میانگین کل',
  percentageOfCount: 'درصد فراوانی',
  prepareReport: 'تهیه‌ی گزارش',
  printWillStartAutomatically:
    'چاپ گزارش به صورت خودکار شروع خواهد شد. در صورت عدم شروع خودکار دکمه‌های Ctrl و P را فشار دهید. همچنین در صورتی عدم مشاهده کامل محتوا در پیش‌نمایش پرینت در بخش scale مقدار مورد نظر را وارد نمایید',
  question: 'پرسش‌',
  list: 'لیست پاسخ‌ها',
  questionsTags: 'برچسب پرسش‌ها',
  reportCategory: 'بخش/واحد:',
  reportNameCouldNotBeEmpty: 'عنوان گزارش نمی‌تواند خالی باشد',
  reportSavedSuccessfully: 'گزارش با موفقیت ذخیره شد',
  reportTitle: 'عنوان گزارش',
  reportTags: 'برچسب‌های گزارش',

  save: 'ذخیره',
  reports: 'گزارش‌ها',
  savedReports: 'گزارش‌های ذخیره شده',
  season: 'فصل',
  searchProvider: 'جستجوی هویت',
  secondLevelBucket: 'انتخاب سری ها',
  selectOneOSavedReportOrCreateANewOneFromSideNav:
    'یکی از گزارش‌های ذخیره شده را از نوار کناری انتخاب کنید یا گزارش جدیدی بسازید',
  selectQuestion: 'پرسشی انتخاب کنید',
  selectReportCategory: 'دسته‌ای را انتخاب کنید...',
  selectTag: 'برچسبی انتخاب کنید',
  seriesCouldNotBeEmpty: 'سری‌ها نمی‌توانند خالی باشند.',
  setting: 'تنظیمات',
  sixMonths: '۶ ماه',
  shahrivar: 'شهریور',
  showCheckPoints: 'نمایش اهداف کلی',
  showOtherCharts: 'نمایش سایر نمودارها',
  split: 'تقسیم‌بندی',
  splitOnTime: 'تقسیم‌بندی زمانی',
  totalTime: 'نمایش کل',
  total: 'کل',
  start: 'شروع',
  submit: 'ارسال',
  subQuestion: 'گام',
  sum: 'جمع',
  table: 'جدولی',
  tableRev: 'جدولی معکوس',
  barRev: 'میله‌ای عمودی',
  stack: 'میله‌ای تجمیعی',
  stackRev: 'میله‌ای تجمیعی معکوس',
  pie: 'دایره‌ای',
  tag: 'برچسب',
  tagFilters: 'فیلتر برچسب‌ها',
  target: 'هدف',
  tenDays: '۱۰ روز',
  thirtyDays: '۳۰ روز',
  thereIsNoReadyReportToPrint: 'گزارش آماده‌ای برای چاپ وجود ندارد!',
  thereIsNoSavedReportYet: 'گزارش ذخیره شده‌ای وجود ندارد.',
  thereIsNoValuesForTheReport: 'مقداری برای گزارش مورد نظر وجود ندارد',
  threeDays: '۳ روز',
  threeMonths: '۳ ماه',
  threeYear: '۳ سال',
  tir: 'تیر',
  title: 'عنوان',
  toEnd: 'تا انتهای',
  totalScore: 'امتیاز کل',
  totalAvg: 'میانگین کل',
  totalValue: 'مقدار کل',
  twelveMonths: '۱۲ ماه',
  twoHalfYear: 'دو نیم‌سال',
  twoSeason: '۲ فصل',
  twoWeeks: '۲ هفته',
  twoYear: '۲ سال',
  untilTheEndOfThisMonth: 'این ماه',
  untilTheEndOfSpring: 'تا انتهای بهار',
  untilTheEndOfSummer: 'تا انتهای تابستان',
  untilTheEndOfAutumn: 'تا انتهای پاییز',
  untilTheEndOfWinter: 'تا انتهای زمستان',
  update: 'به‌روزرسانی',
  week: 'هفته',
  withoutName: 'بدون نام',
  year: 'سال',
  reportsGenerated(count: number) {
    const lang = getLanguageBaseOnTZ();
    return lang === 'fa'
      ? `${count} گزارش ایجاد شد. `
      : `${count} report(s) generated.`;
  },
  copyContent(templateName: string, partName: string) {
    return i18n.t('copyContent', { ns: 'survey', templateName, partName });
  },
  splitOn(
    questionName: string,
    useValue: boolean,
    surveyName: string,
    timeScale: TimeScale
  ) {
    let s = this.amount;
    if (!useValue) s = this.percentage;
    s = `${s} ${surveyName}`;
    return `${s} (به تفکیک ${questionName} در ${this.getRangeName(timeScale)})`;
  },

  choiceSelectCount(timeScale: TimeScale) {
    return `فراوانی انتخاب گزینه‌ها (به تفکیک ${this.getRangeName(timeScale)})`;
  },
  choiceSelectPercent(timeScale: TimeScale) {
    return `درصد انتخاب گزینه‌ها (به تفکیک ${this.getRangeName(timeScale)})`;
  },
  reportNameExtractor(survey: ISurveyView) {
    return (
      survey.fields?.find((it) => it.name === 'conf_reportNamePrefix')?.value ||
      survey.name
    );
  },
  reportInTime(useValue: boolean, survey: ISurveyView, timeScale: TimeScale) {
    let s = this.amount;
    if (!useValue) s = this.percentage;
    s = `${s} ${this.reportNameExtractor(survey)}`;
    return `${s} (به تفکیک ${this.getRangeName(timeScale)})`;
  },
  reportInTimePerAxis(
    useValue: boolean,
    survey: ISurveyView,
    timeScale: TimeScale
  ) {
    let s = this.amount;
    if (!useValue) s = this.percentage;
    s = `${s} ${this.reportNameExtractor(survey)}`;
    return `${s} (به تفکیک محور و ${this.getRangeName(timeScale)})`;
  },
  reportInTimePerItem(
    useValue: boolean,
    timeScale: TimeScale,
    itemName: string
  ) {
    let s = this.amount;
    if (!useValue) s = this.percentage;
    s = `${s} ${itemName}`;
    return `${s} (به تفکیک ${this.getRangeName(timeScale)})`;
  },
  reportInSpecificTime(
    useValue: boolean,
    survey: ISurveyView,
    timeScale: TimeScale
  ) {
    let s = this.amount;
    if (!useValue) s = this.percentage;
    s = `${s} ${this.reportNameExtractor(survey)}`;
    return `${s} (به تفکیک محور در ${this.getRangeName(timeScale)})`;
  },
  reportInTimePerUser(
    useValue: boolean,
    survey: ISurveyView,
    timeScale: TimeScale
  ) {
    let s = this.amount;
    if (!useValue) s = this.percentage;
    s = `${s} ${this.reportNameExtractor(survey)}`;
    return `${s} (به تفکیک فرد و ${this.getRangeName(timeScale)})`;
  },
  splitOnAndTime(
    questionName: string,
    useValue: boolean,
    survey: ISurveyView,
    timeScale: TimeScale
  ) {
    let s = this.amount;
    if (!useValue) s = this.percentage;
    s = `${s} ${this.reportNameExtractor(survey)}`;
    return `${s} (به تفکیک ${questionName} و ${this.getRangeName(timeScale)}) `;
  },

  getRangeName: (range: TimeScale) => {
    const lang = getLanguageBaseOnTZ();
    switch (range) {
      case 'day':
        return lang === 'fa' ? 'روز' : 'day';
      case 'week':
        return lang === 'fa' ? 'هفته' : 'week';
      case 'month':
        return lang === 'fa' ? 'ماه' : 'month';
      case 'season':
        return lang === 'fa' ? 'فصل' : 'season';
      case 'twoSeason':
        return lang === 'fa' ? 'نیم‌سال' : '1/2 of a Year';
      case 'year':
        return lang === 'fa' ? 'سال' : 'year';
    }
  },
};
